var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.75V15.75H2V8.75C2 7.36667 2.41667 6.1375 3.25 5.0625C4.08333 3.9875 5.16667 3.28333 6.5 2.95V2.25C6.5 1.83333 6.64583 1.47917 6.9375 1.1875C7.22917 0.895833 7.58333 0.75 8 0.75C8.41667 0.75 8.77083 0.895833 9.0625 1.1875C9.35417 1.47917 9.5 1.83333 9.5 2.25V2.95C10.8333 3.28333 11.9167 3.9875 12.75 5.0625C13.5833 6.1375 14 7.36667 14 8.75V15.75H16V17.75H0ZM8 20.75C7.45 20.75 6.97917 20.5542 6.5875 20.1625C6.19583 19.7708 6 19.3 6 18.75H10C10 19.3 9.80417 19.7708 9.4125 20.1625C9.02083 20.5542 8.55 20.75 8 20.75ZM4 15.75H12V8.75C12 7.65 11.6083 6.70833 10.825 5.925C10.0417 5.14167 9.1 4.75 8 4.75C6.9 4.75 5.95833 5.14167 5.175 5.925C4.39167 6.70833 4 7.65 4 8.75V15.75Z",
    fill: "#28398A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.9f0163e12d9e2d5f741ba8d0a62ad12a.svg";
export { ForwardRef as ReactComponent };